import React from 'react';
import PropTypes from 'prop-types';
import WormA from '../../../assets/svg/WormA';
import WormB from '../../../assets/svg/WormB';
import styles from './worm.css';

const Worm = ({ type }) => {
  return (
    <div className={styles.wrapper}>
      {(type === 'a' && <WormA />) || (type === 'b' && <WormB />)}
    </div>
  );
};

Worm.defaultProps = {
  type: 'a',
};

Worm.propTypes = {
  type: PropTypes.string,
};

export default Worm;
